import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { type FC } from "react";
import RowBasic, { type SingleRowBasicProps } from "./RowBasic";
import TableWithSkeleton from "./TableWithSkeleton";

interface RowsProps {
	rows?: SingleRowBasicProps[];
	titles?: string[];
}

const BasicTable: FC<RowsProps> = ({ titles, rows }) => {
	if (!titles || !rows) {
		return <TableWithSkeleton />;
	}
	return (
		<TableContainer component={Box}>
			<Table aria-label="table">
				<TableHead>
					<TableRow>
						{titles.map((title) => (
							<TableCell key={title}>{title}</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, index) => (
						<RowBasic key={index} row={row} titles={titles} />
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}

export default BasicTable;
